module.exports = __webpack_public_path__ + "static/media/curtain-cleaning-service-icon.e4437b9e.svg";